import { TextDecoration, normal, underline, strikethrough } from "@cloudinary/transformation-builder-sdk/qualifiers/textDecoration";
export { TextDecoration, normal, underline, strikethrough };
